import { useMutation as e, useQuery as t, useQueryClient as n } from "@tanstack/react-query";
import { http as r, toListPage as i } from "@frontends/data-access-spg-api";
//#region src/lib/api/mappers.ts
function a(e) {
	return {
		id: e.id,
		platform: e.platform,
		externalId: e.external_id,
		name: e.name
	};
}
function o(e) {
	return {
		platform: e.platform,
		external_id: e.externalId,
		name: e.name
	};
}
//#endregion
//#region src/lib/api/channelsApi.ts
async function s(e) {
	let { data: t } = await r.get("/channels", { signal: e });
	return t.map(a);
}
async function c(e) {
	let { data: t } = await r.post("/channels", o(e));
	return a(t);
}
var l = (e) => `/channels/${encodeURIComponent(e)}`;
async function u(e, t) {
	await r.patch(l(e), { name: t });
}
async function d(e) {
	await r.delete(l(e));
}
//#endregion
//#region src/lib/queries.ts
var f = {
	all: ["channels"],
	list: () => [...f.all, "list"]
};
function p(e, t) {
	let n = t.query.toLowerCase();
	return (t.platform === "all" || e.platform === t.platform) && (e.name.toLowerCase().includes(n) || e.externalId.toLowerCase().includes(n));
}
function m(e, n) {
	return t({
		queryKey: f.list(),
		queryFn: ({ signal: e }) => s(e),
		select: (t) => i(t.filter((e) => p(e, n)), e, (e, t) => e[t])
	});
}
function h() {
	return t({
		queryKey: f.list(),
		queryFn: ({ signal: e }) => s(e)
	});
}
//#endregion
//#region src/lib/mutations.ts
function g() {
	let t = n();
	return e({
		mutationFn: c,
		onSuccess: () => t.invalidateQueries({ queryKey: f.list() })
	});
}
var _ = ["instances"];
function v() {
	let t = n();
	return e({
		mutationFn: ({ id: e, name: t }) => u(e, t),
		onSuccess: () => Promise.all([t.invalidateQueries({ queryKey: f.list() }), t.invalidateQueries({ queryKey: _ })])
	});
}
function y() {
	let t = n();
	return e({
		mutationFn: d,
		onSuccess: () => t.invalidateQueries({ queryKey: f.list() })
	});
}
//#endregion
export { f as channelsQueryKeys, h as useAllChannelsQuery, m as useChannelsQuery, g as useCreateChannelMutation, y as useDeleteChannelMutation, v as useRenameChannelMutation };
